import React, { Suspense, useRef, useState } from 'react';
import { Button, Empty } from 'antd';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { useTranslation } from 'react-i18next';
import { NewRoomModal } from 'components/Modals';
import classes from './Rooms.module.scss';
import { useNavigate } from 'react-router';
import RowLoader from 'components/Sceletons/RowLoader';
import { setDataRoom } from 'store/slices/dataRoomSlice';
import RegistrationTimeline from 'components/RegistrationTimeline/RegistrationTimeline';
import { setSelectedKeys } from 'store/slices/windowStateSlice';

const isBillingActive = window.REACT_APP_IS_BILLING_ACTIVE !== 'REPLACE_REACT_APP_IS_BILLING_ACTIVE' ? window.REACT_APP_IS_BILLING_ACTIVE : process.env.REACT_APP_IS_BILLING_ACTIVE;

const Rooms = () => {
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [showFirstLoginMessage, setShowFirstLoginMessage] = useState(false);

  const { userData, available_rooms, isLoadingRooms } = useAppSelector((state) => state.userData);
  const { logoutInProcess } = useAppSelector((state) => state.windowState);
  
  const isFirstRender = useRef(true);

  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate()

  React.useEffect(() => {
    dispatch(setSelectedKeys(['rooms']));
    dispatch(setDataRoom(null));
  }, [])

  React.useEffect(() => {
    const firstLoginFlag = localStorage.getItem('isFirstLogin');
    const isNeedToShowWelcomeMessage = !isFirstRender.current && available_rooms.length === 0 && !isLoadingRooms && !logoutInProcess;    
    if (firstLoginFlag === 'true' || isNeedToShowWelcomeMessage) {
      setShowFirstLoginMessage(true);
      const hasRoom = available_rooms.some((room) => !room.invite_id);
      if (hasRoom) {
        localStorage.removeItem('isFirstLogin');
        setShowFirstLoginMessage(false);
      }
    }
    isFirstRender.current = false;
  }, [available_rooms]);

  // RETURNED BILLING
  const onCreateRoomClick = () => isBillingActive === 'true' ? navigate('/tariffs') : setIsVisibleModal(true);

  const content = {
    true: (
      <div className={classes.gettingStartedContainer}>
        <div className={classes.gettingStartedContent}>
          <RegistrationTimeline currentStep={2} />
          <div className={classes.gettingStartedMessage}>
            {t('gettingStarted.welcomeMessage')}
          </div>
          <Button 
            className={classes.emptyCreate}
            onClick={onCreateRoomClick}
          >
            {t('Header.management.create')}
          </Button>
        </div>
      </div>
    ),
    false: (
      available_rooms.length || !userData
        ? <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          className={classes.tabsEmptyText}
          description={ isLoadingRooms || !userData
            ? <RowLoader width={400} padding={'0 0 0 10px'} height={20} borderradius={5}/>
            : <span className={classes.emptyText}>
              {t('Rooms.chooseRoom')}.
              <br />
            </span>
          }
        />
        : <Empty
          className={classes.tabsEmptyText}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={isLoadingRooms
            ? <RowLoader width={400} padding={'0 0 0 10px'} height={20} borderradius={5}/>
            : <span>
              {t('Documents.management.noAvailable')}.
              <br />
              {t('Rooms.prompt')} <br />
              <Button className={classes.emptyCreate} onClick={onCreateRoomClick}>
                {t('Header.management.create')}
              </Button>
            </span>
          }
        />
    )
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.mainSpace}>
        {content[String(showFirstLoginMessage) as keyof typeof content]}
      </div>

      {isVisibleModal && (
        <Suspense fallback={<div />}>
          <NewRoomModal open={isVisibleModal} onCancel={() => setIsVisibleModal(false)} />
        </Suspense>
      )}
    </div>
  );
};

export default Rooms;
